// https://github.com/orestbida/cookieconsent
// https://github.com/orestbida/cookieconsent/tree/v2.9
import 'vanilla-cookieconsent';
import { merge } from 'lodash-es';
import prestashop from 'prestashop';
// import { DataLayer } from '@/services/datalayer';

type TCookieReadonly = boolean;
type TCookieEnabled = boolean;

type TCookies = {
    [key: string]: [TCookieReadonly, TCookieEnabled];
};

// GLOBAL CONST
declare global {
    interface Window {
        cookieconsent?: {
            rgpd: LanguageSetting;
        };
    }
}

const i18n = prestashop.i18n;

const cookieName = prestashop.cookieName as string;

const cookies: TCookies = {
    mandatory: [true, true],
    advertising: [false, false],
    // analytics: [false, false],
    personalization: [false, false],
};

// FUNCTIONS
const makeCookieBlock = (
    category: string,
    readonly = false,
    enabled = true,
) => ({
    toggle: {
        value: category,
        readonly,
        enabled,
    },
});

const makeCookieBlocks = (cookies: TCookies) => {
    return Object.entries(cookies).map(([value, [readonly, enabled]]) =>
        makeCookieBlock(value, readonly, enabled),
    );
};

const getTemplateLang = (): LanguageSetting => {
    const defaultLang: LanguageSetting = {
        consent_modal: {
            title: 'Cookies & vie privée',
            description:
                'Nous utilisons des cookies pour améliorer votre expérience.',
            primary_btn: {
                text: 'Accepter tout',
                role: 'accept_all',
            },
            secondary_btn: {
                text: 'Paramètres',
                role: 'settings',
            },
        },
        settings_modal: {
            title: 'Paramètres des cookies',
        },
    };

    if (!i18n) {
        console.warn('prestashop.i18n pas encore défini');
        return defaultLang;
    }

    return merge(defaultLang, i18n);
};

const makeLang = (iso_code: string) => ({
    [iso_code]: merge(getTemplateLang(), {
        consent_modal: {
            title: 'Cookies & vie privée',
            primary_btn: { text: 'Accepter tout', role: 'accept_all' },
            secondary_btn: { text: 'Paramètres', role: 'settings' },
        },
        settings_modal: {
            title: 'Paramètres des cookies',
            blocks: [...makeCookieBlocks(cookies)],
        },
    }),
});

const cc = initCookieConsent();

const updateConsent = () => {
    // const { accepted_categories } = cc.getUserPreferences();
    // DataLayer.push({
    //     event: 'content',
    //     event_name: 'update',
    //     value: {
    //         functionality_storage: 'granted',
    //         ad_storage: accepted_categories.includes('advertising')
    //             ? 'granted'
    //             : 'denied',
    //         ad_personalization: accepted_categories.includes('advertising')
    //             ? 'granted'
    //             : 'denied',
    //         ad_user_data: accepted_categories.includes('advertising')
    //             ? 'granted'
    //             : 'denied',
    //         analytics_storage: accepted_categories.includes('analytics')
    //             ? 'granted'
    //             : 'denied',
    //         personalization_storage: accepted_categories.includes(
    //             'personalization',
    //         )
    //             ? 'granted'
    //             : 'denied',
    //     },
    // });
};

const ccConfig: UserConfig = {
    revision: 0,
    current_lang: 'fr',
    cookie_name: cookieName,
    page_scripts: true,
    mode: 'opt-in',
    force_consent: true,
    cookie_expiration: 395,
    cookie_necessary_only_expiration: 1,

    onAccept: updateConsent,
    onChange: updateConsent,

    gui_options: {
        consent_modal: {
            layout: 'cloud',
            transition: 'slide',
            swap_buttons: true,
        },
        settings_modal: {
            layout: 'bar',
            position: 'right',
            transition: 'slide',
        },
    },

    languages: {
        ...makeLang('fr'),
    },
};

const initCookieConsentManager = () => {
    cc.run(ccConfig);

    // DataLayer.push({
    //     event: 'content',
    //     event_name: 'default',
    //     value: {
    //         functionality_storage: 'granted',
    //         ad_storage: 'denied',
    //         ad_personalization: 'denied',
    //         ad_user_data: 'denied',
    //         analytics_storage: 'denied',
    //         personalization_storage: 'denied',
    //     },
    // });

    window.addEventListener('open-cookieconsent', () => {
        cc.showSettings(0);
    });

    return cc;
};

export { initCookieConsentManager as CookieConsent };
